export function formatPostalcodel(postalcode) {

    let postalcodeFormated = postalcode.slice(0, 5) + '-' + postalcode.slice(5);
    return postalcodeFormated;
}